import React from 'react';
import CorreoOlvideContraseniaFrm from './correoOlvideContrasenia.frm';

export default class CorreoOlvideContrasenia extends React.Component {

    render() {
        return (
            <div>
                <CorreoOlvideContraseniaFrm onSubmit={this.submit} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/gnp-olvide-contrasenia/correoOlvideContrasenia.cmpt.js